import {
  CorporationChatBotPage,
  CorporationDetailPage,
  CorporationListPage,
  CorporationPersonnelListPage,
  CorporationProductListPage,
} from "@Elements";
import { DashboardBaseRoute } from "./Dashboard.route";
import { createRoute, redirect } from "@tanstack/react-router";

export const CorporationBaseRoute = createRoute({
  getParentRoute: () => DashboardBaseRoute,
  path: "/corporation",
  staticData: {
    TITLE: "Kurumsal Yönetim",
    IS_BASE_ROUTE: true,
  },
  beforeLoad: (route) => {
    if (route.location.pathname === CorporationBaseRoute.fullPath)
      throw redirect({
        to: CorporationListRoute.fullPath,
      });
  },
});

export const CorporationListRoute = createRoute({
  getParentRoute: () => CorporationBaseRoute,
  path: "/list",
  component: CorporationListPage,
  staticData: {
    TITLE: "Firmalar",
  },
});

export const CorporationAddRoute = createRoute({
  getParentRoute: () => CorporationBaseRoute,
  path: "/add",
  component: CorporationDetailPage,
  staticData: {
    TITLE: "Yeni Şirket",
    PARENT_ROUTE: CorporationListRoute,
  },
});

export const CorporationEditRoute = createRoute({
  getParentRoute: () => CorporationBaseRoute,
  path: "/edit/$id",
  component: CorporationDetailPage,
  staticData: {
    TITLE: "Şirket Düzenle",
    PARENT_ROUTE: CorporationListRoute,
  },
});

export const CorporationProductListRoute = createRoute({
  getParentRoute: () => CorporationBaseRoute,
  path: "/products/$id",
  component: CorporationProductListPage,
  staticData: {
    TITLE: "Firmaya Ait Ürünler",
    PARENT_ROUTE: CorporationListRoute,
  },
});

export const CorporationPersonnelListRoute = createRoute({
  getParentRoute: () => CorporationBaseRoute,
  path: "/personnels/$id",
  component: CorporationPersonnelListPage,
  staticData: {
    TITLE: "Firmaya Ait Personeller",
    PARENT_ROUTE: CorporationListRoute,
  },
});

export const CorporationChatBotRoute = createRoute({
  getParentRoute: () => CorporationBaseRoute,
  path: "/chatbot/$id",
  component: CorporationChatBotPage,
  staticData: {
    TITLE: "Firmaya Ait ChatBot Kullanımı",
    PARENT_ROUTE: CorporationListRoute,
  },
});

export const CorporationRouteTree = CorporationBaseRoute.addChildren([
  CorporationListRoute,
  CorporationAddRoute,
  CorporationEditRoute,
  CorporationProductListRoute,
  CorporationPersonnelListRoute,
  CorporationChatBotRoute,
]);
